import React, {useEffect, useState} from "react";

import ChatBot from "@/Components/ChatBot/ChatBot.jsx";
import {Head} from "@inertiajs/react";
import {useLaravelReactI18n} from "laravel-react-i18n";
import Header from "@/Components/Header.jsx";

import previewVideo from '../../video/header-bg-video.mp4';
import NewsBlock from "@/Components/NewsBlock.jsx";
import Footer from "@/Components/Footer.jsx";
import DecorBlob from "@/Components/Decor/DecorBlob.jsx";
import DecorContainer from "@/Components/Decor/DecorContainer.jsx";
import Breadcrumbs from "@/Components/Breadcrumbs.jsx";

export default function News(pageProps) {
    const {t} = useLaravelReactI18n();
    const email = "info@vivanti.eu";
    const handleEmailClick = () => {
        window.location.href = `mailto:${email}`;
    };

    const [selectedCategoryID, setSelectedCategoryID] = useState(0);
    const [newsData, setNewsData] = useState(pageProps.news);
    const [tagsData, setTagsData] = useState([]);
    let filteredNews = [];

    useEffect(() => {
        for (let tag in pageProps.tags) {
            setTagsData((oldArr) => {
                let newArr = [...oldArr];
                newArr.push(pageProps.tags[tag]);
                return newArr;
            });
        }
    }, []);

    useEffect(() => {
        if (selectedCategoryID === 0) return setNewsData(pageProps.news);

        filteredNews = [];
        setNewsData([]);

        pageProps.news.forEach((news) => {
            news.tags.forEach((tag) => {
                if (tag.id === selectedCategoryID) filteredNews.push(news);
            })
        });

        setNewsData(filteredNews);
    }, [selectedCategoryID]);

    const clickCategoryHandler = (id) => setSelectedCategoryID(id);

    return (
        <>
            <ChatBot
                csrf_token={pageProps.csrf_token}
                user_id={pageProps.user_id}
                is_admin={pageProps.is_admin}
            ></ChatBot>

            <Head>
                <title>{t("site.newsPage.pageTitle")}</title>
                <meta name="title" content={t("site.newsPage.pageTitle")}/>
                <meta name="description" content={t("site.newsPage.pageDescription")}/>

                <meta property="og:title" content={t("site.newsPage.pageTitle")}/>
                <meta
                    property="og:description"
                    content={t("site.newsPage.pageDescription")}
                />
                <meta
                    property="og:image"
                    content={require('@images/social-banners/main.jpg')}
                />
            </Head>

            <Header locale={pageProps.locale} menu={pageProps.menu}></Header>

            <div className="header-preview">
                <div className="header-preview__video">
                    <video autoPlay loop muted>
                        <source src={previewVideo} type="video/mp4"></source>
                    </video>
                </div>
                <div className="category-news container mt-72px">
                    <div className="container__inner">
                        <Breadcrumbs breadcrumbs={pageProps.breadcrumbs} />
                        <div className="flex flex-col gap-18px mb-24px">
                            <h1>{t("site.newsPage.title")}</h1>
                            <div className="categories">
                                <div
                                    className={selectedCategoryID === 0 ? 'category-block is-selected' : 'category-block'}
                                    onClick={() => clickCategoryHandler(0)}>
                                    <span>{t("site.tags.all")}</span>
                                </div>
                                {
                                    tagsData.map((tag) => {
                                        return <div key={tag.id}
                                                    className={selectedCategoryID === tag.id ? 'category-block is-selected' : 'category-block'}
                                                    onClick={() => clickCategoryHandler(tag.id)}
                                        >
                                            <span>{tag.name}</span>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="news container mb-80px ph:mb-100px">
                <div className="container__inner">
                    <div className="news__content">
                        {
                            newsData.map((data) => {
                                return <NewsBlock key={data.id}
                                    slug={data.slug}
                                    imgURL={data.image}
                                    tags={data.tags}
                                    date={data.published_at_localized}
                                    title={data.name}
                                    text={data.description}
                                    locale={pageProps.locale}
                                />
                            })
                        }
                    </div>
                </div>

                <DecorContainer zIndex={2}>
                    <DecorBlob
                        typeNum={1}
                        width={1000}
                        blur={0}
                        rotate={-320}
                        opacity={0.7}
                        x={230}
                        y={100}
                        animations={["pulse"]}
                        animDuration={8}
                        gsapMove={true}
                    />
                    <DecorBlob
                        typeNum={3}
                        width={1000}
                        blur={200}
                        rotate={-320}
                        opacity={0.7}
                        x={290}
                        y={100}
                    />
                </DecorContainer>
            </section>

            <Footer pageProps={pageProps}></Footer>
        </>
    );
}
